/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Grid, TextField } from '@material-ui/core';
import ImageResultLine1 from './images/img_result_line1.svg';
import ImageResultLine2 from './images/img_result_line2.svg';
import ImageResultLine3 from './images/img_result_line3.svg';
import ImageResultLine5 from './images/img_result_line5.svg';
import ImageResultLine7 from './images/img_result_line7.svg';
import ImageDesk1 from './images/img_desk1.svg';
import ImageDesk2 from './images/img_desk2.svg';
import ImageDesk3 from './images/img_desk3.svg';
import ImageYen from './images/img_yen.svg';
import ImageMen from './images/img_men.svg';
import ImageFukidashiBlack from './images/img_fukidashi_black.svg';
import ImageFukidashiRed from './images/img_fukidashi_red.svg';
import ImageAreaKako from './images/img_area_kako.svg';
import ImageOfficeKako from './images/img_office_kako.svg';
import Chart00 from './Chart00.js';
import Chart01 from './Chart01.js';
import ImageFukidashi1 from './images/img_fukidashi1.svg';
import ImageFukidashi3 from './images/img_fukidashi3.svg';
import ImageChart from './ImageChart.js';

class ResultItem extends React.Component {
  render() {
    let shusha;
    let remote;
    let kotei;
    let free;
    let remotefeeP;
    let teatejyukyu;
    //編集モードの時
    if (this.props.isEditMode) {
      shusha = (
        <Box position="relative" marginBottom={1}>
          <img className="line7" src={ImageFukidashi3} height={35} />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} textAlign="center">
            <TextField
              style={{ width: 50 }}
              value={this.props.shusha}
              onChange={(e) => {
                this.props.handleShushaChange(e.target.value);
                this.props.calc();
              }}
              inputProps={{
                style: { fontSize: 15, textAlign: 'center', fontFamily: 'Noto Sans JP', fontWeight: 900 },
                min: 0,
              }}
              InputProps={{
                disableUnderline: true,
              }}
            ></TextField>
          </Box>
        </Box>
      );
      remote = (
        <Box position="relative" marginBottom={1}>
          <img className="line7" src={ImageFukidashi3} height={35} />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} textAlign="center">
            <TextField
              style={{ width: 50 }}
              value={this.props.remote}
              onChange={(e) => {
                this.props.handleRemoteChange(e.target.value);
                this.props.calc();
              }}
              inputProps={{
                style: { fontSize: 15, textAlign: 'center', fontFamily: 'Noto Sans JP', fontWeight: 900 },
                min: 0,
              }}
              InputProps={{
                disableUnderline: true,
              }}
            ></TextField>
          </Box>
        </Box>
      );
      kotei = (
        <Box position="relative" marginBottom={1}>
          <img className="line7" src={ImageFukidashi3} height={35} />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} textAlign="center">
            <TextField
              style={{ width: 50 }}
              value={this.props.kotei}
              onChange={(e) => {
                this.props.handleKoteiChange(e.target.value);
                this.props.calc();
              }}
              inputProps={{
                style: { fontSize: 15, textAlign: 'center', fontFamily: 'Noto Sans JP', fontWeight: 900 },
                min: 0,
              }}
              InputProps={{
                disableUnderline: true,
              }}
            ></TextField>
          </Box>
        </Box>
      );
      free = (
        <Box position="relative" marginBottom={1}>
          <img className="line7" src={ImageFukidashi3} height={35} />
          <Box position="absolute" top={0} left={0} right={0} bottom={0} textAlign="center">
            <TextField
              style={{ width: 50 }}
              value={this.props.free}
              onChange={(e) => {
                this.props.handleFreeChange(e.target.value);
                this.props.calc();
              }}
              inputProps={{
                style: { fontSize: 15, textAlign: 'center', fontFamily: 'Noto Sans JP', fontWeight: 900 },
                min: 0,
              }}
              InputProps={{
                disableUnderline: true,
              }}
            ></TextField>
          </Box>
        </Box>
      );

      remotefeeP = (
        <Box position="relative" textAlign="center" marginTop={1}>
          <img src={ImageFukidashi1} height={25} />
          <Box position="absolute" top={-5} left={30} right={0} bottom={0} textAlign="left">
            <TextField
              style={{ width: 50 }}
              value={this.props.remotefeeP}
              onChange={(e) => {
                this.props.handelRemoteFeeChange(e.target.value);
                this.props.calc();
              }}
              inputProps={{
                style: { fontSize: 15, textAlign: 'center', fontFamily: 'Noto Sans JP', fontWeight: 900 },
                min: 0,
              }}
              InputProps={{
                disableUnderline: true,
              }}
            ></TextField>
          </Box>
        </Box>
      );
      teatejyukyu = (
        <Box position="relative" textAlign="center" marginTop={1}>
          <img src={ImageFukidashi1} height={25} />
          <Box position="absolute" top={-5} left={30} right={0} bottom={0} textAlign="left">
            <TextField
              style={{ width: 50 }}
              value={this.props.teatejyukyu}
              onChange={(e) => {
                this.props.handleTeateJukyuChange(e.target.value);
                this.props.calc();
              }}
              inputProps={{
                style: { fontSize: 15, textAlign: 'center', fontFamily: 'Noto Sans JP', fontWeight: 900 },
                min: 0,
              }}
              InputProps={{
                disableUnderline: true,
              }}
            ></TextField>
          </Box>
        </Box>
      );
    } else {
      shusha = (
        <Box>
          <h5 className="result_discripsion3">
            {this.props.shusha}
            <span> %</span>
          </h5>
          <img className="line7" src={ImageResultLine7} />
        </Box>
      );
      remote = (
        <Box>
          <h5 className="result_discripsion3">
            {this.props.remote}
            <span> %</span>
          </h5>
          <img className="line7" src={ImageResultLine7} />
        </Box>
      );
      kotei = (
        <Box>
          <h5 className="result_discripsion3">
            {this.props.kotei}
            <span> %</span>
          </h5>
          <img className="line7" src={ImageResultLine7} />
        </Box>
      );
      free = (
        <Box>
          <h5 className="result_discripsion3">
            {this.props.free}
            <span> %</span>
          </h5>
          <img className="line7" src={ImageResultLine7} />
        </Box>
      );
      remotefeeP = (
        <Box position="relative" textAlign="center" marginTop={1}>
          <img src={ImageResultLine5} height={20} />
          <Box position="absolute" top={-7} left={30} right={0} bottom={0} textAlign="left">
            <h6 className="result_discripsion5">
              {this.props.remotefeeP}
              <span> 万円/月</span>
            </h6>
          </Box>
        </Box>
      );
      teatejyukyu = (
        <Box position="relative" textAlign="center" marginTop={1}>
          <img src={ImageResultLine5} height={20} />
          <Box position="absolute" top={-7} left={30} right={0} bottom={0} textAlign="left">
            <h6 className="result_discripsion5">
              {this.props.teatejyukyu}
              <span> %</span>
            </h6>
          </Box>
        </Box>
      );
    }
    let chart00Data = [
      {
        name: '',
        pv: this.props.shusha,
        uv: this.props.remote,
      },
    ];
    let chart01Data = [
      {
        index: 0,
        name: '',
        value: this.props.kotei,
        fill: '#DADBDB',
      },
      {
        index: 1,
        name: '',
        value: this.props.free,
        fill: this.props.fillColor,
      },
    ];

    //増減率の吹き出しの色
    let fukidashi1;
    let fukidashi2;
    let fukidashi3;
    let areaChart;
    let officeChart;
    let officePChart;

    if (this.props.isKako) {
      areaChart = <img src={ImageAreaKako} />;
      officeChart = <img className="img_officeP" src={ImageOfficeKako} />;
      officePChart = <img className="img_officeP" src={ImageOfficeKako} />;
    } else {
      areaChart = <ImageChart zogen={this.props.area_zogen} type="area" />;
      officeChart = <ImageChart zogen={this.props.officefee_zogen} type="fee" />;
      officePChart = <ImageChart zogen={this.props.officefeeP_zogen} type="fee" />;

      if (this.props.area_zogen < 0) {
        fukidashi1 = <img src={ImageFukidashiRed} />;
      } else {
        fukidashi1 = <img src={ImageFukidashiBlack} />;
      }
      if (this.props.officefee_zogen < 0) {
        fukidashi2 = <img src={ImageFukidashiRed} />;
      } else {
        fukidashi2 = <img src={ImageFukidashiBlack} />;
      }
      if (this.props.officefeeP_zogen < 0) {
        fukidashi3 = <img src={ImageFukidashiRed} />;
      } else {
        fukidashi3 = <img src={ImageFukidashiBlack} />;
      }
    }

    return (
      <Box m={2}>
        <Box textAlign="center">
          <img src={ImageResultLine1} />
          <Box marginTop={3} left={0} right={0} marginBottom={4}>
            <h2 className="result_tittle">{this.props.name}</h2>
            <h5 className="office_discription1">{this.props.nameEN}</h5>
            <h6 className="office_discription2">{this.props.discript}</h6>
          </Box>

          <Box position="relative">
            <img src={ImageResultLine2} />
            <Box position="absolute" top={0} left={0} right={0}>
              <Box marginTop={3}></Box>
              <Grid container justify="center">
                <Grid item xs={3}>
                  {shusha}
                </Grid>
                <Grid item xs={5}>
                  <h5 className="result_discripsion2">出社率</h5>
                </Grid>
                <Grid item xs={3}>
                  {remote}
                </Grid>
              </Grid>
              <Box position="relative">
                <Box marginTop={-1} marginLeft={0} marginRight={0}>
                  <Chart00 data={chart00Data} fillColor={this.props.fillColor} />
                </Box>
                <Box position="absolute" top={6} left={0} right={0} bottom={0}>
                  <Grid container justify="center">
                    <Grid item xs={3}>
                      <h5 className="result_discripsion1">出社</h5>
                    </Grid>
                    <Grid item xs={5}></Grid>
                    <Grid item xs={3}>
                      <h5 className="result_discripsion1">リモート</h5>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              <Box marginTop={3}>
                <h5 className="result_discripsion2">フリーアドレス率</h5>
              </Box>
              <Box position="relative">
                <Box marginTop={4} marginLeft={6} marginRight={6} bottom={0}>
                  <Chart01 data={chart01Data} />
                </Box>
                <Box position="absolute" top={-20} left={0} right={0} bottom={5}>
                  <Grid container justify="center">
                    <Grid item xs={3}>
                      <h5 className="result_discripsion1">固定席</h5>
                      {kotei}
                      <Box p={1}>
                        <img src={ImageDesk1} />
                      </Box>
                    </Grid>
                    <Grid item xs={5}></Grid>
                    <Grid item xs={3}>
                      <h5 className="result_discripsion1_2">フリーアドレス</h5>
                      {free}
                      <Box p={1}>
                        <img src={ImageDesk2} />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box textAlign="left" marginTop={3} paddingLeft={0.5} paddingRight={0.5}>
          <Box height={120}>
            <Box height={50}>
              <Grid container>
                <Grid item xs={8}>
                  <h5 className="result_discripsion2">必要面積</h5>
                  <h5 className="result_discripsion5">
                    {this.props.area}
                    <span> ㎡</span>
                  </h5>
                </Grid>
                <Grid item xs={4}>
                  <Box position="relative" textAlign="center" p={1}>
                    {fukidashi1}
                    <Box position="absolute" top={7} left={0} right={0} bottom={0}>
                      <h5 className="result_zogen" hidden={this.props.isKako}>
                        {(this.props.area_zogen <= 0 ? '' : '+') + this.props.area_zogen}
                        <span> %</span>
                      </h5>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box position="relative" marginTop={4}>
              {areaChart}
              <Box position="absolute" top={-15} left={0} right={0} bottom={0} paddingLeft={3}>
                <img src={ImageDesk3} height={20} />
              </Box>
            </Box>
          </Box>

          <Box height={120} marginTop={3}>
            <Box height={50}>
              <Grid container>
                <Grid item xs={8}>
                  <h5 className="result_discripsion2">オフィス費用</h5>
                  <h5 className="result_discripsion2_2">(賃料+リモートワーク手当)</h5>
                  <h5 className="result_discripsion5">
                    {this.props.officefee}
                    <span> 万円/月</span>
                  </h5>
                </Grid>
                <Grid item xs={4}>
                  <Box position="relative" textAlign="center" p={1}>
                    {fukidashi2}
                    <Box position="absolute" top={7} left={0} right={0} bottom={0}>
                      <h5 className="result_zogen" hidden={this.props.isKako}>
                        {(this.props.officefee_zogen <= 0 ? '' : '+') + this.props.officefee_zogen}
                        <span> %</span>
                      </h5>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box position="relative" marginTop={4}>
              {officeChart}
              <Box position="absolute" top={-8} left={0} right={0} bottom={0} paddingLeft={3}>
                <img src={ImageYen} height={20} />
              </Box>
            </Box>
          </Box>

          <Box height={120} marginTop={3}>
            <Box height={60}>
              <Grid container>
                <Grid item xs={8}>
                  <h5 className="result_discripsion2">一人当たりの</h5>
                  <h5 className="result_discripsion2">オフィス費用</h5>
                  <h5 className="result_discripsion5">
                    {this.props.officefeeP}
                    <span> 万円/月</span>
                  </h5>
                </Grid>
                <Grid item xs={4}>
                  <Box position="relative" textAlign="center" p={1}>
                    {fukidashi3}
                    <Box position="absolute" top={7} left={0} right={0} bottom={0}>
                      <h5 className="result_zogen" hidden={this.props.isKako}>
                        {(this.props.officefeeP_zogen <= 0 ? '' : '+') + this.props.officefeeP_zogen}
                        <span> %</span>
                      </h5>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box marginTop={2}>
              <Grid container alignItems="flex-end">
                <Grid item xs={8}>
                  <Box>{officePChart}</Box>
                </Grid>
                <Grid item xs={4} bottom={0}>
                  <Box textAlign="right">
                    <img className="img_officeP" src={ImageMen} height="100%" />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>

        <Box position="relative" marginTop={3}>
          <img src={ImageResultLine3} />
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            paddingTop={3}
            paddingLeft={1}
            paddingRight={1}
            textAlign="left"
          >
            <Box marginTop={1}>
              <Grid container alignItems="center">
                <Grid item xs={6}>
                  <h6 className="result_discripsion2_2">一人当たり</h6>
                  <h6 className="result_discripsion2_2">リモートワーク手当</h6>
                </Grid>
                <Grid item xs={6}>
                  {remotefeeP}
                </Grid>
              </Grid>
            </Box>
            <Box marginTop={0.5}>
              <Grid container alignItems="center">
                <Grid item xs={6}>
                  <h6 className="result_discripsion2_2">手当受給率</h6>
                </Grid>
                <Grid item xs={6}>
                  {teatejyukyu}
                </Grid>
              </Grid>
            </Box>
            <Box marginTop={0.5}>
              <Grid container alignItems="center">
                <Grid item xs={7}>
                  <h6 className="result_discripsion2_2">リモートワーク手当総額</h6>
                </Grid>
                <Grid item xs={5}>
                  <Box>
                    <h6 className="result_discripsion5">
                      {this.props.teatetotal}
                      <span> 万円/月</span>
                    </h6>
                  </Box>
                </Grid>
              </Grid>
              <hr color="#333333"></hr>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default ResultItem;
